import type { IDivision } from '@src/models/interfaces/division.interface';
import { ACCESS_TYPES } from '@src/packages/utils/access';

export interface EmergencyDivisionOption {
  id: string;
  name: string;
  access?: string;
}

export const toDivisionMap = (
  divisions: Record<string, IDivision & { access?: string }> | IDivision[] | null | undefined,
): Record<string, IDivision & { access?: string }> => {
  if (!divisions || Array.isArray(divisions)) return {};
  return divisions;
};

export const isManageableDivisionAccess = (access?: string): boolean =>
  access === ACCESS_TYPES.ADMIN || access === ACCESS_TYPES.OWNER;

export const buildEmergencyDivisionOptions = ({
  assignedDivisions,
  profileOrgDivisions,
  hasOrganizationWideReadAccess,
  isOrganizationAdmin,
}: {
  assignedDivisions: Record<string, IDivision & { access?: string }> | IDivision[] | null | undefined;
  profileOrgDivisions?: Record<string, IDivision> | null;
  hasOrganizationWideReadAccess: boolean;
  isOrganizationAdmin: boolean;
}): EmergencyDivisionOption[] => {
  const fromAssigned = Object.entries(toDivisionMap(assignedDivisions)).map(([id, division]) => ({
    id,
    name: division.name ?? id,
    access: division.access,
  }));
  if (fromAssigned.length > 0 || !hasOrganizationWideReadAccess) {
    return fromAssigned;
  }
  return Object.entries(profileOrgDivisions ?? {}).map(([id, division]) => ({
    id,
    name: division.name ?? id,
    access: isOrganizationAdmin ? ACCESS_TYPES.ADMIN : ACCESS_TYPES.READER,
  }));
};

export const canCreateEmergencyTypes = ({
  isOrganizationAdmin,
  divisionOptions,
  canManageDivision,
}: {
  isOrganizationAdmin: boolean;
  divisionOptions: EmergencyDivisionOption[];
  canManageDivision: (divisionId: string) => boolean;
}): boolean =>
  isOrganizationAdmin || divisionOptions.some(division => canManageDivision(division.id));
